import type { FC } from "react";

import type { IconName } from "@similarweb/icons";

import type { ICategory, ICustomCategory } from "app/common/services/categoryService.types";
import { QueryBarItem } from "app/components/compare/QueryBarItem";

import { CategorySearchContainer } from "../styles";
import type { ICategoriesData, ICategoryModalProps } from "../types";

import { IndustryAnalysisQueryBarItem } from "./IndustryAnalysisQueryBarItem";
import { IndustryAnalysisSearch } from "./IndustryAnalysisSearch";

interface ISingleCategoryQueryBarItemProps {
    categoriesData: ICategoriesData;
    selectedCategory: ICategory | ICustomCategory | null;
    isSearchOpen: boolean;
    showOnlyCategories?: boolean;
    showOnlyCustom?: boolean;
    placeholder?: string;
    categoryModalProps?: ICategoryModalProps;
    isPartnerPage?: boolean;
    customResolveItemIcon?: (item: ICategory, isChild: boolean) => IconName;
    onItemClick: (item: ICategory) => void;
    onQueryBarItemClick: () => void;
    onSearchClose: () => void;
}

export const SingleCategoryQueryBarItem: FC<ISingleCategoryQueryBarItemProps> = ({
    categoriesData,
    isSearchOpen,
    showOnlyCategories,
    showOnlyCustom,
    placeholder,
    categoryModalProps,
    isPartnerPage,
    customResolveItemIcon,
    selectedCategory,
    onItemClick,
    onQueryBarItemClick,
    onSearchClose,
}) => {
    const itemComponent = (
        <IndustryAnalysisQueryBarItem
            category={selectedCategory}
            onItemClick={onQueryBarItemClick}
        />
    );

    const searchComponent = (
        <CategorySearchContainer>
            <IndustryAnalysisSearch
                onItemClick={onItemClick}
                onClose={onSearchClose}
                showOnlyCategories={showOnlyCategories}
                showOnlyCustom={showOnlyCustom}
                placeholder={placeholder}
                categoryModalProps={categoryModalProps}
                isPartnerPage={isPartnerPage}
                customResolveItemIcon={customResolveItemIcon}
                selectedCategory={selectedCategory}
            />
        </CategorySearchContainer>
    );

    return (
        <QueryBarItem
            id={categoriesData.selectedCategoryId}
            isLoading={false}
            activeItem={isSearchOpen ? categoriesData.selectedCategoryId : null}
            renderComponent={itemComponent}
            searchComponent={searchComponent}
        />
    );
};
